import { createContext, Dispatch, SetStateAction } from 'react'

import { ProfessionalContractType, ProfessionalContractTypeFilterKeyString } from 'InstitutionalManagement/types'

type CustomFormProfessionalContractTypeSelectionDrawerManagerContextType = {
  view: string
  setView: Dispatch<SetStateAction<string>>
  selectedProfessionalContractType: ProfessionalContractType
  setSelectedProfessionalContractType: (newProfessionalContractType: ProfessionalContractType) => void
  filter: ProfessionalContractTypeFilterKeyString
  setFilter: Dispatch<SetStateAction<ProfessionalContractTypeFilterKeyString>>
  questionKey: string
  professionalContractTypes: ProfessionalContractType[]
  loadingProfessionalContractTypes: boolean
  setLoadingProfessionalContractTypes: Dispatch<SetStateAction<boolean>>
}

const defaultValue = {
  view: '',
  setView: () => {},
  selectedProfessionalContractType: {},
  setSelectedProfessionalContractType: () => {},
  filter: {},
  setFilter: () => {},
  questionKey: '',
  professionalContractTypes: [],
  loadingProfessionalContractTypes: false,
  setLoadingProfessionalContractTypes: () => {},
}

const CustomFormProfessionalContractTypeSelectionDrawerManagerContext =
  createContext<CustomFormProfessionalContractTypeSelectionDrawerManagerContextType>(defaultValue)

export default CustomFormProfessionalContractTypeSelectionDrawerManagerContext
